import { Slide } from "@jelly/lesson";
import { task as task01 } from "../../../../../task/course-02/lesson-18/task-01";

const task: Slide = {
  titleHtml: `According to the estimation of Lane and Tranel, what increase in speech level can be expected<br>when the noise in a room increases from 65 dB to 80 dB? `,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
